module.exports = __webpack_public_path__ + "media/gc-landing-page-720p.dec5239a.mp4";